import { useRouter, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

export const useProfileWeb = () => {
  const { public: { endpoints: { PROFILE_WEB }, HOST } } = useRuntimeConfig()
  const router = useRouter()
  const genre = computed(() => router.currentRoute.value.meta.genre)
  const applyGenreQuery = (url: string, isAppend: boolean = false) => {
    let result = url
    if (genre.value) {
      if (isAppend) {
        result = `${result}&genre=${genre.value}`
      } else {
        result = `${result}?genre=${genre.value}`
      }
    }
    return result
  }

  const contactLink = computed(() => {
    const sellingOrderId = router.currentRoute.value.query['sellingOrderId']
    const sellingOrderQuery = typeof sellingOrderId==='string' ? `?sellingOrderId=${sellingOrderId}` : ''
    return applyGenreQuery(`${PROFILE_WEB}/contact${sellingOrderQuery}`)
  })
  const externalTransmissionLink = computed(() => applyGenreQuery(`${PROFILE_WEB}/external-transmission`))
  const myPageLink = computed(() => applyGenreQuery(PROFILE_WEB))
  const privacyPolicyLink = computed(() => applyGenreQuery(`${PROFILE_WEB}/privacy-policy`))
  const profilePageLink = `${PROFILE_WEB}/settings/profile`
  const signupLink = computed(() => {
    const base = `${PROFILE_WEB}/signup`
    const redirectTo = encodeURIComponent(HOST + router.currentRoute.value.fullPath)
    return applyGenreQuery(`${base}?redirectTo=${redirectTo}`, true)
  })
  const signinLink = computed(() => {
    const base = `${PROFILE_WEB}/signin`
    const redirectTo = encodeURIComponent(HOST + router.currentRoute.value.fullPath)
    return applyGenreQuery(`${base}?redirectTo=${redirectTo}`, true)
  })
  const verificationLink = computed(() => {
    const base = `${PROFILE_WEB}/verify`
    const redirectTo = encodeURIComponent(HOST + router.currentRoute.value.fullPath)
    return applyGenreQuery(`${base}?redirectTo=${redirectTo}`, true)
  })
  const specifiedCommercialTransactionsActLink = computed(() => applyGenreQuery(`${PROFILE_WEB}/specified-commercial-transactions-act`))
  const termsOfServiceLink = computed(() => applyGenreQuery(`${PROFILE_WEB}/terms-of-service`))
  const sellingOrdersLink = computed(() => applyGenreQuery(`${PROFILE_WEB}/selling/orders`))
  const refreshSessionEndpoint = `${PROFILE_WEB}/api/refresh-session`

  const getCustomRedirectLink = (mode: 'signup' | 'signin', redirectPath: string) => {
    const base = `${PROFILE_WEB}/${mode}`
    const redirectTo = encodeURIComponent(HOST + redirectPath)
    return applyGenreQuery(`${base}?redirectTo=${redirectTo}`, true)
  }
  const getCustomRedirectProfilePageLink = (redirectPath: string) => {
    const redirectTo = encodeURIComponent(HOST + redirectPath)
    return applyGenreQuery(`${profilePageLink}?redirectTo=${redirectTo}`, true)
  }

  const getSellingOrderDetailPage = (sellingOrderId: number) => applyGenreQuery(`${PROFILE_WEB}/selling/orders/${sellingOrderId}`)

  return {
    myPageLink,
    contactLink,
    externalTransmissionLink,
    privacyPolicyLink,
    profilePageLink,
    signupLink,
    signinLink,
    verificationLink,
    specifiedCommercialTransactionsActLink,
    termsOfServiceLink,
    sellingOrdersLink,
    getCustomRedirectLink,
    getCustomRedirectProfilePageLink,
    getSellingOrderDetailPage,
    refreshSessionEndpoint
  }
}
